import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { ProjectsProvider } from './provider';
import ProjectsDefault from './Default';
import ProjectsPlayful from './Playful';

export function Projects(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return <ProjectsProvider>{isPlayfulStudentTheme ? <ProjectsPlayful {...props} /> : <ProjectsDefault {...props} />}</ProjectsProvider>;
}
